<template>
  <layout :title="pageTitle">
    <section class="section content">
      <div class="search">
        <inertia-link :href="route('question-sets.create')">
          <b-button class="is-primary"> Add Question Set </b-button>
        </inertia-link>
      </div>
      <hr />
      <viewQuestionSetsTable :questionSets="questionSets" />
    </section>
  </layout>
</template>

<script>
import Layout from './Layout';
import viewQuestionSetsTable from '../../Components/Management/ViewQuestionSetsTable';

export default {
  components: {
    Layout,
    viewQuestionSetsTable,
  },
  props: {
    questionSets: Array,
  },
  data() {
    return {
      isEmpty: false,
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isHoverable: false,
      isFocusable: false,
      isLoading: false,
      hasMobileCards: true,
      pageTitle: 'Manage Question Sets',
    };
  },
};
</script>
